"use client"

import { MapPinPlusInside } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinPlusInsideIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinPlusInsideIcon = component(Icon)({ as: MapPinPlusInside })
